import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import clsx from 'clsx';
import { Modal } from 'react-bootstrap';
import { Button, ButtonColorType, ButtonType } from '../Button';
import FormModalContext from './FormModal.context';
import { IFormModalProviderProps } from './FormModalProvider.types';
import FormModalProviderTabButton from './FormModalProviderTabButton';
// @ts-ignore
import modalCloseIcon from '../../assets/icons/modal-close.svg';
import './FormModalProvider.scss';
import StyledFormModalProvider from './FormModalComponent';
import { NoneButton } from '../AttachmentTag';

const FormModalProviderDeprecated: React.FC<IFormModalProviderProps> = (
  props: IFormModalProviderProps
) => {
  const { Provider } = FormModalContext;
  const {
    children,
    className,
    stepsDefinition,
    show,
    onHide,
    mode,
    onSubmit,
    onStepChange,
    finishButtonText,
    finishButtonDisabled,
    finishButtonPending,
    onAlternativeFinishAction,
    alternativeFinishButtonText,
    alternativeFinishButtonDisabled,
    alternativeFinishButtonPending,
    hideBackButton,
    locked,
    toastContainerId,
    permanentSections,
    nextButtonId,
    backButtonId,
    finishButtonId,
    closeButtonId
  } = props;
  const [actualStep, setActualStep] = React.useState(0);

  React.useEffect(() => setActualStep(0), [show]);

  return (
    <StyledFormModalProvider>
      <Modal
        className={clsx([
          'form-modal-provider',
          'modal',
          'fade',
          'center',
          className ?? '',
          mode === 'Add' ? 'modal-with-footer' : ''
        ])}
        show={show}
        backdrop="static"
        keyboard={false}
        onHide={() => {
          if (onHide) {
            onHide();
          }
        }}
      >
        <form onSubmit={onSubmit}>
          <div className="modal-wrapper">
            <Provider value={actualStep}>
              <div className="modal-close-button">
                <NoneButton
                  type={ButtonType.BUTTON}
                  onClick={() => {
                    if (onHide) {
                      onHide();
                    }
                  }}
                >
                  <img src={modalCloseIcon} alt="close-icon" />
                </NoneButton>
              </div>
              <div className="modal-navigation">
                {stepsDefinition
                  .sort((n1, n2) => n1.pageNumber - n2.pageNumber)
                  .map(({ pageNumber, disable, icon, title, testId }) => (
                    <FormModalProviderTabButton
                      testId={testId}
                      pageNumber={pageNumber}
                      actualStep={actualStep}
                      disable={disable}
                      setActualStep={setActualStep}
                      icon={icon}
                      title={title}
                      onStepChange={onStepChange}
                    />
                  ))}
                {mode !== 'Add' &&
                  permanentSections &&
                  permanentSections.length > 0 && (
                    <div>
                      <div className="tabs-separator" />
                      {permanentSections.map(
                        ({ title, icon, pageNumber, testId }) => (
                          <FormModalProviderTabButton
                            testId={testId}
                            pageNumber={pageNumber}
                            actualStep={actualStep}
                            disable={false}
                            setActualStep={setActualStep}
                            icon={icon}
                            title={title}
                            onStepChange={onStepChange}
                          />
                        )
                      )}
                    </div>
                  )}
              </div>
              <div className="modal-body-wrapper">
                <div className="h3-medium modal-body">{children}</div>
                {mode === 'Add' && (
                  <div className="modal-footer">
                    <div id={toastContainerId} className="toast-container" />
                    {actualStep !== 0 && !hideBackButton ? (
                      <Button
                        className="modal-footer-button m-r-12"
                        type={ButtonType.BUTTON}
                        onClick={() => {
                          if (onStepChange) {
                            onStepChange(actualStep, actualStep - 1);
                          }
                          if (!stepsDefinition[actualStep - 1].disable) {
                            setActualStep(actualStep - 1);
                          }
                        }}
                        colorType="grey"
                        text="Back"
                        testId={backButtonId}
                      />
                    ) : null}
                    {actualStep === stepsDefinition.length - 1 ? (
                      <>
                        {onAlternativeFinishAction ? (
                          <Button
                            className="modal-footer-button m-r-12"
                            type={ButtonType.BUTTON}
                            onClick={() => onAlternativeFinishAction()}
                            text={alternativeFinishButtonText ?? 'Close'}
                            colorType={ButtonColorType.WHITE}
                            pending={alternativeFinishButtonPending}
                            disabled={alternativeFinishButtonDisabled}
                            testId={closeButtonId}
                          />
                        ) : null}
                        <Button
                          className="modal-footer-button"
                          type={ButtonType.SUBMIT}
                          text={finishButtonText ?? 'Finish'}
                          disabled={locked || finishButtonDisabled}
                          pending={finishButtonPending}
                          testId={finishButtonId}
                        />
                      </>
                    ) : (
                      <Button
                        className="modal-footer-button"
                        type="button"
                        onClick={() => {
                          if (onStepChange) {
                            onStepChange(actualStep, actualStep + 1);
                          }
                          if (!stepsDefinition[actualStep + 1].disable) {
                            setActualStep(actualStep + 1);
                          }
                        }}
                        text="Next step"
                        disabled={locked}
                        testId={nextButtonId}
                      />
                    )}
                  </div>
                )}
              </div>
            </Provider>
          </div>
        </form>
        <ReactTooltip id="modalTooltip" multiline />
      </Modal>
    </StyledFormModalProvider>
  );
};

export default FormModalProviderDeprecated;
